import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment/moment'
import { apiDispatchesList, apiDispatchesView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/dispatches/getData', async datas => {
    const { data } = await apiDispatchesList(datas)
    return data
})

export const getView = createAsyncThunk('admin/dispatches/getView', async id => {
    if (!id) return viewData
    const { data } = await apiDispatchesView(id)
    data.documents = []
    data.document_remove = []
    data.pallets = data.pallets && data.pallets.length !== 0 ? data.pallets : []
    return data
})

const viewData = {
    affiliate_id: '',
    dispatch_date: '',
    pickup_by: '',
    manifest_no: '',
    documents: [],
    document_remove: [],
    comment: '',
    pallets: [],
}

export const dispatchesSlice = createSlice({
    name: 'admin/dispatches',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            start: moment().startOf('month').locale('en').format('YYYY-MM-DD'),
            end: moment().endOf('month').locale('en').format('YYYY-MM-DD'),
            affiliate_id: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
        setAffiliate: (state, { payload }) => {
            state.table.page = 1
            state.table.affiliate_id = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setDate, setAffiliate } = dispatchesSlice.actions

export default dispatchesSlice.reducer
